export default "/SiteCollectionImages/react-apps/nykredit/src/fonts/Montserrat-Light.woff";